<template>
  <div>
    <v-dialog
      :ref="modal.key"
      v-model="open"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="pa-0 ma-0">
        <v-toolbar dark dense color="primary" class="pl-6">
          <v-toolbar-title>{{ modal.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-switch
              dark
              class="mt-3"
              v-model="showMainDocument"
              @change="loadMainDocument"
              :label="$t('ShowMainDocument')"
            ></v-switch>
            <v-btn dark text class="ml-2" @click="open = false">{{
              $t("Close")
            }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-0 ma-0">
          <v-container class="py-0 my-0">
            <v-row>
              <v-col>
                <PdfViewer
                  :ref="viewerKey"
                  :height="getHeight"
                  :isSearchResult="false"
                />
              </v-col>
              <v-col v-if="showMainDocument">
                <PdfViewer
                  :ref="mainDocumentViewerKey"
                  :height="getHeight"
                  :isSearchResult="false"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AttachmentService from "@/services/AttachmentService";
import DocumentService from "@/services/DocumentService";
import PdfViewer from "@/components/document/PdfViewer";
import { EventBus } from "@/eventBus.js";

export default {
  name: "AttachmentDisplayModal",
  components: {
    PdfViewer,
  },
  data() {
    return {
      modal: {
        title: this.$t("DocumentAttachments"),
        key: "attachmentDisplayModal",
      },
      showMainDocument: false,
      open: false,
      viewerKey: "documentAttachmentPdfViewer",
      mainDocumentReRender: 0,
      fileId: 0,
      mainDocumentId: null,
    };
  },
  computed: {
    viewerInstance() {
      return this.$refs[this.viewerKey];
    },
    mainDocumentViewerKey() {
      return `documentAttachmentDocPdfViewer${this.mainDocumentReRender}`;
    },
    mainDocumentViewerInstance() {
      return this.$refs[this.mainDocumentViewerKey];
    },
    getHeight() {
      return window.innerHeight - 90;
    },
  },
  methods: {
    loadMainDocument() {
      var self = this;
      localStorage.setItem(
        "modalAttachmentShowMainDocument",
        this.showMainDocument
      );
      if (this.showMainDocument) {
        this.mainDocumentReRender++;
        DocumentService.canDisplay(this.mainDocumentId).then((canDisplay) => {
          let file = encodeURIComponent("/static/defaultDocument.pdf");

          if (canDisplay) {
            file = encodeURIComponent(
              DocumentService.display(this.mainDocumentId)
            );
          }

          self.mainDocumentViewerInstance.load(file);
        });
      }
    },
    displayDocumentAttachment(mainDocumentId, attachment) {
      this.mainDocumentId = mainDocumentId;
      this.showMainDocument =
        localStorage.getItem("modalAttachmentShowMainDocument") == "true";
      this.loadMainDocument();
      this.show();
      this.modal.title = attachment.description;
      var self = this;
      AttachmentService.canDisplay(attachment.id).then((canDisplay) => {
        let file = encodeURIComponent("/static/defaultDocument.pdf");

        if (canDisplay) {
          file = encodeURIComponent(AttachmentService.display(attachment.id));
        }

        self.viewerInstance.load(file);
      });
    },
    async onMergeDocumentAttachments(mainDocumentId, attachments){
      this.mainDocumentId = mainDocumentId;
      this.showMainDocument = localStorage.getItem("modalAttachmentShowMainDocument") == "true";
      this.loadMainDocument();
      this.show();
      let self = this;
      this.modal.title = attachments.map(object => object.description).join('-');

      let someDocumentCannotBeDisplayed = false;
      for (let i = 0; i < attachments.length; i++){
        AttachmentService.canDisplay(attachments[i].id).then((canDisplay) => {
          if(!canDisplay){
            someDocumentCannotBeDisplayed = true;
          }
        });
      }

      if (someDocumentCannotBeDisplayed)
        return;

      let listOfIds = attachments.map(object => object.id).join(',');

      let files = await AttachmentService.merge(listOfIds);

      self.viewerInstance.load(encodeURIComponent(files));
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
  mounted() {
    EventBus.$on("displayDocumentAttachment", (attachmentId) => {
      this.displayDocumentAttachment(attachmentId);
    });
  },
  destroyed() {
    EventBus.$off("displayDocumentAttachment");
  },
};
</script>
